import React from 'react';
import { IonButton, IonIcon, IonItem, useIonAlert } from '@ionic/react';
import { closeOutline, downloadOutline, ellipseOutline } from 'ionicons/icons';
import '../pages/ChaptersPage.scss';

interface MarkAsReadBarComponentProps {
  downloadList: string[];
  deselectAll: () => void;
  download: () => void;
  setShowBar: (showBar: boolean) => void;
}

const DownloadBarComponent: React.FC<MarkAsReadBarComponentProps> = ({ downloadList, deselectAll, download, setShowBar }: MarkAsReadBarComponentProps) => {
  const [presentAlert] = useIonAlert();
  return (
    <IonItem className="download-bar">
      {downloadList.length !== 0 && (
        <IonButton color="secondary" onClick={deselectAll} slot="end">
          <IonIcon icon={ellipseOutline} />
        </IonButton>
      )}
      <IonButton
        color="secondary"
        slot="end"
        onClick={() =>
          presentAlert({
            header: 'Télécharger la selection ?',
            buttons: [
              {
                cssClass: 'alert-button-cancel',
                text: 'Annuler',
                role: 'cancel',
              },
              {
                cssClass: 'alert-button-validation',
                text: 'OK',
                role: 'confirm',
                handler: download,
              },
            ],
          })
        }
      >
        <IonIcon icon={downloadOutline} />
      </IonButton>
      <IonButton color="secondary" slot="end" onClick={() => setShowBar(false)}>
        <IonIcon icon={closeOutline} />
      </IonButton>
    </IonItem>
  );
};

export default DownloadBarComponent;
